export const en = {
    ak_sync_error: 'We could not synchronize your profile with our supplier, please contact the {supportChatLink}',
};
